import { Button, Form } from 'antd';
import React, { useState } from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import Debug from 'components/Debug';
import TelcodePhoneVerify from 'components/forms/TelcodePhoneVerify';
import TelPhone from 'components/forms/TelPhone';
import Toast from 'components/Toast';
import Track from 'components/Track';
import security from 'stores/security';
import store from '../../store';

const PhoneChangeModule: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const $formutil = useForm();
    const navigate = useNavigate();
    const location = useLocation();

    const submit = async () => {
        const { $params, $invalid, $getFirstError, $batchDirty } = $formutil;

        if ($invalid) {
            Toast.show($getFirstError());
            $batchDirty(true);
        } else {
            setLoading(true);

            try {
                const params = {
                    ...$params,
                    verify_token: (location.state as any)?.verify_token || '',
                    content: undefined
                };

                await store.modifySetting('phone', params);

                await security.getStatus();

                navigate(location.pathname.replace('3', '4'));
            } catch (err) {
                Toast.show(err);

                // 操作时长过长，重新回到第一步
                if (err.error_code === 11804) {
                    navigate('/profile/security/modify/phone');
                }
            }

            setLoading(false);
        }
    };

    const { $params } = $formutil;

    if (!location?.state) {
        return <Navigate to="../1" replace />;
    }

    return (
        <Form onFinish={submit} layout="vertical">
            <TelPhone />
            <TelcodePhoneVerify process="modify_phone" />
            <CardButtonWrap>
                <Track eventModel="安全中心" eventType="手机认证_修改" eventName="修改_下一步2">
                    <Button
                        block
                        type="primary"
                        size="large"
                        className="verify-identify-btn btn-important"
                        loading={loading}
                        disabled={!$params.verify_code}
                        htmlType="submit">
                        {__('下一步')}
                    </Button>
                </Track>
            </CardButtonWrap>
            <Debug data={$params} />
        </Form>
    );
};

export default withForm(PhoneChangeModule);
